const round2 = value => Math.round((value + Number.EPSILON) * 100) / 100;

export function parseAmount(raw) {
  if (typeof raw === 'number') return raw;
  const text = String(raw ?? '').trim().replace(',', '.');
  if (!text) return NaN;
  return Number(text);
}

export function calcDiferencia(declarado, rendido) {
  return round2(parseAmount(declarado) - parseAmount(rendido));
}

export function calcTotalFinal(flete, adicionales, descuentos) {
  const extra = parseAmount(adicionales);
  const desc = parseAmount(descuentos);
  return round2(parseAmount(flete) + (Number.isNaN(extra) ? 0 : extra) - (Number.isNaN(desc) ? 0 : desc));
}

export function validateRendicion({ declarado, rendido, observaciones }) {
  const monto = parseAmount(rendido);
  if (!Number.isFinite(monto) || monto < 0) {
    return { ok: false, diferencia: 0, error: 'Ingrese un monto rendido válido (no negativo).' };
  }
  const diferencia = calcDiferencia(declarado, monto);
  if (diferencia !== 0 && !String(observaciones || '').trim()) {
    return { ok: false, diferencia, error: 'Ingrese observaciones: el monto rendido difiere del declarado.' };
  }
  return { ok: true, diferencia, error: '' };
}

export function validateLiquidacion({ flete, adicionales, descuentos }) {
  const read = raw => (String(raw ?? '').trim() === '' ? 0 : parseAmount(raw));
  const extra = read(adicionales);
  const desc = read(descuentos);
  if (!Number.isFinite(extra) || extra < 0 || !Number.isFinite(desc) || desc < 0) {
    return { ok: false, totalFinal: 0, adicionales: 0, descuentos: 0, error: 'Adicionales y descuentos deben ser números no negativos.' };
  }
  const totalFinal = calcTotalFinal(flete, extra, desc);
  if (totalFinal < 0) {
    return { ok: false, totalFinal, adicionales: extra, descuentos: desc, error: 'El total final no puede ser negativo.' };
  }
  return { ok: true, totalFinal, adicionales: extra, descuentos: desc, error: '' };
}
